import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import { api } from '@/api'
import Button from '@/components/Button'
import CabinetContestCard from '@/components/Cards/CabinetContestCard'
import { flagIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React from 'react'
import style from './styles/contests.module.scss'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import { useConfig } from '@/hooks'

const CabinetContests = (): React.ReactElement => {
  const config = useConfig()

  return (
    <FetcherList
      initFilter={{ page_size: 10 }}
      isScrollTop={false}
      isHistoryPush={false}
      api={api.getContestsUser}
    >
      {({ results, status, showMore, isNext }: IFetcherListResults<any[]>) => {
        return (
          <>
            {/* <Filters handleFilter={loadData} initFilters={filterParams} /> */}
            {results.length === 0 && status === dataStates.loaded
              ? (
                <div className={style.empty}>
                  <GxIcon src={flagIcon} className={style.empty__icon} />
                  <span className={style.empty__text}>
                    Ты еще не участвовал в&nbsp;конкурсах
                  </span>
                  <Button wide highlight href={config.live_like_a_host} className={style.empty__button}>
                    Принять участие
                  </Button>
                </div>
                )
              : null}

            <ul className={style.cards_list}>
              {results.map((el) => {
                const obj = el.property_konkurs_value[0]
                return (
                  <li className={style.cards__item} key={el.id}>
                    <CabinetContestCard
                      id={obj.id}
                      image={obj.preview_picture?.[0] ?? ''}
                      title={obj.name}
                      theme={obj.preview_text}
                      date={obj.date_create}
                    />
                  </li>
                )
              })}
            </ul>
            {isNext
              ? (
                <Button
                  disabled={status === dataStates.loading}
                  onClick={showMore}
                  size='large'
                  wide
                  outline
                  className={style.inst__more}
                >
                  Показать еще
                </Button>
                )
              : null}
          </>
        )
      }}
    </FetcherList>
  )
}

export default CabinetContests
